// React, Next
import { useRouter } from 'next/router'

// MUI
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { Button } from '@mui/material'

// Custom
import Link from 'next/link'
import { translateHref } from 'assets/functions/links'
import Section from '../sections/Section'

// Config
import i18nextConfig from 'next-i18next.config'

// Style
import { getFontBody, getFontH3 } from '@/assets/theme/fonts'
import themeColors from 'assets/theme/colors'

type PropTypes = {
  title: string
  subTitle: string
  title2?: string
  subTitle2?: string
  button?: string
  marginBottom?: string
  marginTop?: string
}
export default function GetStartedSection(props: PropTypes) {
  const router = useRouter()
  const currentLocale = router.query.locale || i18nextConfig.i18n.defaultLocale

  const getSection = () => (
    <Box>
      <Typography
        variant="h3"
        fontSize={getFontH3()}
        sx={{
          color: themeColors.bg.start,
          textAlign: 'left',
          marginBottom: '1rem',
          fontWeight: 'bold'
        }}
      >
        {props.title}
      </Typography>
      <Typography
        variant="h3"
        fontSize={getFontBody()}
        sx={{
          color: themeColors.gray.mid,
          textAlign: 'left',
          marginBottom: '3rem',
          lineHeight: 1.5
        }}
      >
        {props.subTitle}
      </Typography>
      {props.title2 && (
        <>
          <Typography
            variant="h3"
            fontSize={getFontH3()}
            sx={{
              color: themeColors.bg.start,
              textAlign: 'left',
              marginBottom: '1rem',
              fontWeight: 'bold'
            }}
          >
            {props.title2}
          </Typography>
          <Typography
            variant="h3"
            fontSize={getFontBody()}
            sx={{
              color: themeColors.gray.mid,
              textAlign: 'left',
              lineHeight: 1.5
            }}
          >
            {props.subTitle2}
          </Typography>
        </>
      )}
      {props.button && (
        <Box
          sx={{
            marginTop: '4rem',
            width: '100%',
            display: 'flex',
            justifyContent: 'center'
          }}
        >
          <Link href={translateHref(currentLocale, 'contact')}>
            <Button
              variant="contained"
              sx={{
                minWidth: 150,
                background: themeColors.success.main,
                '&:hover': {
                  background: themeColors.success.darker
                }
              }}
            >
              {props.button}
            </Button>
          </Link>
        </Box>
      )}
    </Box>
  )

  // *** MAIN RENDER ***
  return (
    <Section
      background={themeColors.info.lightest}
      paddingTop="5rem"
      paddingBottom="5rem"
      marginBottom={props.marginBottom}
      marginTop={props.marginTop}
      content={getSection()}
    />
  )
}
